<script lang="ts" setup>
import { useElementSize } from '@vueuse/core'

import { useGift } from '@consumer/composables/gift'

import '@consumer/styles/giftly_image.scss'
import type GiftTemplate from '@consumer/types/GiftTemplate'
import { titleize } from 'inflection'
import miscGiftPreviewForIcon from '@consumer/assets/icons/misc/gift-preview-for.svg?svgicon'

const { gift } = defineProps<{ gift: GiftTemplate }>()

const emit = defineEmits<{ clickBackground: [] }>()

const { formattedAmount, tagline } = useGift(() => gift as any)

const designUrl = computed(() => (
  `https://assets2.giftly.com/giftly-assets/patterns/${gift.giftlyMetadata?.designName ?? 'classic-blue'}-oxi.png`
))

const wrapperRef = ref<HTMLElement>()
const { width: wrapperWidth } = useElementSize(wrapperRef)

watch(
  wrapperWidth,
  () => {
    if (wrapperWidth.value) {
      const cardEl = wrapperRef.value?.firstChild as HTMLDivElement
      const baseWidth = cardEl.clientWidth
      const scale = wrapperWidth.value / baseWidth
      cardEl.style.transform = `scale(${scale})`
      cardEl.style.transformOrigin = 'top left'
      wrapperRef.value!.style.height = `${cardEl.clientHeight * scale}px`
    }
  },
)
</script>

<template>
  <div ref="wrapperRef" class="giftly-image-wrapper">
    <div class="giftly-image-v1" @click="emit('clickBackground')">
      <img :src="designUrl" class="giftly-image-v1--background-image">
      <div class="giftly-image-v1--amount">
        {{ formattedAmount }}
      </div>
      <i class="giftly-image-v1--for">
        <GIcon :svg="miscGiftPreviewForIcon" size="36em"/>
      </i>
      <div class="giftly-image-v1--item-and-place">
        <div class="giftly-image-v1--item-and-place--item">
          {{ titleize(gift.itemDescription || 'anything') }} at
        </div>
        <div class="giftly-image-v1--item-and-place--place">
          {{ tagline }}
        </div>
      </div>
    </div>
  </div>
</template>
